export default __webpack_public_path__ + "static/media/vn.aa591ead.svg";